
<div class="search_result">
  <div class="result"
    *ngFor="let addressBook of addressBooks"
    (click)="onView(addressBook)"
    style="cursor: pointer;"
  >
    <h2 class="name"><em class="ti-user"></em>  {{ addressBook?.Name }}</h2>
    <div class="other-info">
      <p class="phone"><em class="ti-mobile"></em> {{ addressBook?.PhoneNo }}</p>
      <p class="email"><em class="ti-email"></em> {{ addressBook?.Email }}</p>
      <p class="account"><em class="ti-info-alt"></em> {{addressBook?.AccountName}}</p>
      <p class="number"><em class="ti-info-alt"></em> {{addressBook?.AccountNo}}</p>
    </div>
  </div>


</div>
